import {DDRFactory} from '../../class/micronutrient-ddr-factory/ddr.factory';
import {DDR} from '../../class/micronutrient-ddr-strategy/ddr.class';
import {DDRTypeEnum} from '../../class/micronutrient-ddr-factory/ddr-type.enum';
import {Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {collapse, DEFAULT_DURATION} from '../../animations/collapse.animation';
import {cloneDeep} from 'lodash';

export interface IMicronutrients {
  _id?: string;
  name: string;
  value: number;
  unitMeasurement: string;
  ddr: number;
}

export const _MICRONUTRIENTS: IMicronutrients[] = [
  {
    _id: 'vitaminA_ug',
    name: 'Vitamina A',
    value: 0,
    unitMeasurement: 'ug',
    ddr: null
  },
  {
    _id: 'vitaminD_ug',
    name: 'Vitamina D',
    value: 0,
    unitMeasurement: 'ug',
    ddr: null
  },
  {
    _id: 'vitaminE_mg',
    name: 'Vatamina e',
    value: 0,
    unitMeasurement: 'ug',
    ddr: null
  },
  {
    _id: 'vitaminK_ug',
    name: 'Vatamina k',
    value: 0,
    unitMeasurement: 'ug',
    ddr: null
  },
  {
    _id: 'vitaminC_mg',
    name: 'Vitamina C',
    value: 0,
    unitMeasurement: 'mg',
    ddr: null
  },
  {
    _id: 'thiamine_mg',
    name: 'Tiamina',
    value: 0,
    unitMeasurement: 'mg',
    ddr: null
  },
  {
    _id: 'riboflavin_mg',
    name: 'riboflavina',
    value: 0,
    unitMeasurement: 'mg',
    ddr: null
  },
  {
    _id: 'niacin_mg',
    name: 'niacina',
    value: 0,
    unitMeasurement: 'mg',
    ddr: null
  },
  {
    _id: 'vitaminB6_mg',
    name: 'Vitamina B6',
    value: 0,
    unitMeasurement: 'mg',
    ddr: null
  },
  {
    _id: 'folate_ug',
    name: 'folato',
    value: 0,
    unitMeasurement: 'ug',
    ddr: null
  },
  {
    _id: 'vitaminB12_ug',
    name: 'Vitamina B12',
    value: 0,
    unitMeasurement: 'ug',
    ddr: null
  },
  {
    _id: 'pantothenicAcid_mg',
    name: 'ácido pantoténico',
    value: 0,
    unitMeasurement: 'ug',
    ddr: null
  },
  {
    _id: 'biotin_ug',
    name: 'biotina',
    value: 0,
    unitMeasurement: 'ug',
    ddr: null
  },
  {
    _id: 'choline_mg',
    name: 'colina',
    value: 0,
    unitMeasurement: 'ug',
    ddr: null
  },
  {
    _id: 'calcium_mg',
    name: 'calcio',
    value: 0,
    unitMeasurement: 'mg',
    ddr: null
  },
  {
    _id: 'chromium_ug',
    name: 'cromo',
    value: 0,
    unitMeasurement: 'ug',
    ddr: null
  },
  {
    _id: 'copper_mg',
    name: 'cobre',
    value: 0,
    unitMeasurement: 'mg',
    ddr: null
  },
  {
    _id: 'fluoride_ug',
    name: 'fluoruro',
    value: 0,
    unitMeasurement: 'ug',
    ddr: null
  },
  {
    _id: 'iodine_ug',
    name: 'yodo',
    value: 0,
    unitMeasurement: 'ug',
    ddr: null
  },
  {
    _id: 'heminicIron_mg',
    name: 'hierro',
    value: 0,
    unitMeasurement: 'mg',
    ddr: null
  },
  {
    _id: 'magnesium_mg',
    name: 'magnesio',
    value: 0,
    unitMeasurement: 'mg',
    ddr: null
  },
  {
    _id: 'manganese_mg',
    name: 'manganeso',
    value: 0,
    unitMeasurement: 'mg',
    ddr: null
  },
  {
    _id: 'phosphorus_mg',
    name: 'fósforo',
    value: 0,
    unitMeasurement: 'mg',
    ddr: null
  },
  {
    _id: 'selenium_ug',
    name: 'selenio',
    value: 0,
    unitMeasurement: 'ug',
    ddr: null
  },
  {
    _id: 'zinc_mg',
    name: 'cinc',
    value: 0,
    unitMeasurement: 'mg',
    ddr: null
  },
  {
    _id: 'sodium_mg',
    name: 'sodio',
    value: 0,
    unitMeasurement: 'mg',
    ddr: null
  },
  {
    _id: 'potassium_mg',
    name: 'potasio',
    value: 0,
    unitMeasurement: 'mg',
    ddr: null
  },
  {
    _id: 'cholesterol_mg',
    name: 'colesterol',
    value: 0,
    unitMeasurement: 'mg',
    ddr: null
  },
  {
    _id: 'ascorbicAcid_mg',
    name: 'ácido ascórbico',
    value: 0,
    unitMeasurement: 'mg',
    ddr: null
  },
  {
    _id: 'ethanol_g',
    name: 'etanol',
    value: 0,
    unitMeasurement: 'g',
    ddr: null
  },
  {
    _id: 'sugar_g',
    name: 'azúcar',
    value: 0,
    unitMeasurement: 'g',
    ddr: null
  },
  {
    _id: 'chloride_mg',
    name: 'cloruro',
    value: 0,
    unitMeasurement: 'mg',
    ddr: null
  },
  {
    _id: 'saturatedFats_g',
    name: 'grasas saturadas',
    value: 0,
    unitMeasurement: 'g',
    ddr: null
  },
  {
    _id: 'monounsaturatedFats_g',
    name: 'grasas monoinsaturadas',
    value: 0,
    unitMeasurement: 'g',
    ddr: null
  },
  {
    _id: 'polyunsaturatedFats_g',
    name: 'grasas poliinsaturadas',
    value: 0,
    unitMeasurement: 'g',
    ddr: null
  },
  {
    _id: 'transFats_g',
    name: 'grasas trans',
    value: 0,
    unitMeasurement: 'g',
    ddr: null
  },
  {
    _id: 'folicAcid_ug',
    name: 'ácido fólico',
    value: 0,
    unitMeasurement: 'ug',
    ddr: null
  },
];

@Component({
  selector: 'app-micronutrient-list',
  templateUrl: './micronutrient-list.component.html',
  styleUrls: ['./micronutrient-list.component.scss'],
  animations: [collapse]
})
export class MicronutrientListComponent implements OnInit, OnChanges {
  /**
   * Propiedad usada para quitar el contenedor de la tarjeta
   */
  @Input() withoutContainer = false;
  @Input() data: IMicronutrients[] = cloneDeep(_MICRONUTRIENTS);
  @Input() title = 'Micronutrientes';
  @Input() description = 'Distribución de macronutrientes';
  @Input() emptyText = 'No hay datos';
  @Input() btnMoreStyle: 'default' | 'small' = 'default'; // Estilo del botón mostrar/ocultar elementos nulos
  @Input() autoSort = false; // Para ordenar automáticamente (DESC) los datos cada que data cambie de valor
  @Input() propertySort = 'value'; // Columna a ordenar
  @Input() typeSort: 'ASC' | 'DESC' = 'DESC'; // Tipo de ordenado (ascendente o descendente)
  @Output() changeMicrosValues: EventEmitter<IMicronutrients[]> = new EventEmitter<IMicronutrients[]>();
  @ViewChild('containerRefProtein') listComponent: ElementRef;
  showMoreMicronutrients = false;
  loading = false;
  DEFAULT_DURATION = DEFAULT_DURATION;
  loadingHeight = 300;
  interval: any;
  sorting = false;

  DDRTypeEnum = DDRTypeEnum;
  strategyName: DDRTypeEnum = DDRTypeEnum.MEN1930;
  ddrStrategy: DDR;
  constructor() { }

  ngOnInit(): void {
    if (!this.autoSort) {
      this.propertySort = null;
    }
    this.initDDRStrategy();
  }

  initDDRStrategy(): void {
    this.ddrStrategy = DDRFactory.createDDRStandar(DDRTypeEnum.MEN1930);
    this.data = this.ddrStrategy.concatDDRValues(this.data);
    this.changeMicrosValues.emit(this.data.filter(item => item.value !== 0));
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes.data) return;
    if (this.autoSort && !this.sorting) {
      this.sortMicronutrients();
    }
    this.initDDRStrategy();
    this.loading = true;
    setTimeout(() => {
      this.loading = false;
      setTimeout(() => {
        this.loadingHeight = this.listComponent?.nativeElement?.offsetHeight - 85;
      }, DEFAULT_DURATION + 1);
    }, 350);
  }

  /**
   * Ordena la  tabla de micronutrientes (primero los que tienen valor)
   */
  sortMicronutrients(): void {
    this.sorting = true;
    const showMore = cloneDeep(this.showMoreMicronutrients);
    this.showMoreMicronutrients = true;
    if (this.interval) {
      this.showMoreMicronutrients = showMore;
      clearInterval(this.interval);
    }
    this.interval = setTimeout(() => {
      if (!this.data || this.data.length === 0) {
        return;
      }
      const typeOfProperty = typeof this.data[0][this.propertySort];
      if (this.typeSort === 'DESC') {
        if (typeOfProperty === 'number') {
          this.data = this.data.sort((a, b) => b[this.propertySort] - a[this.propertySort]);
        } else if (typeOfProperty === 'string') {
          this.data = this.data.sort((a, b) => b[this.propertySort].localeCompare(a[this.propertySort]));
        }
      } else {
        if (typeOfProperty === 'number') {
          this.data = this.data.sort((a, b) => a[this.propertySort] - b[this.propertySort]);
        } else if (typeOfProperty === 'string') {
          this.data = this.data.sort((a, b) => a[this.propertySort].localeCompare(b[this.propertySort]));
        }
      }
      setTimeout(() => {
        this.showMoreMicronutrients = false;
        this.sorting = false;
      }, 50);
    }, this.DEFAULT_DURATION / 2);
  }

  /**
   * Muestra u oculta los micronutrientes que no tienen valor
   * @param action true o false (mostrar u ocultar)
   */
  onShowHideMoreMicronutrients(action?: boolean): void {
    if (action !== undefined) {
      this.showMoreMicronutrients = action;
    } else {
      this.showMoreMicronutrients = !this.showMoreMicronutrients;
    }
  }

  /**
   * Ordena la lista por la propiedad elegida
   * @param property propiedad a ordenar
   */
  onSortByProperty(property: string): void {
    if (this.propertySort !== property) {
      this.propertySort = property;
    } else {
      this.typeSort = this.typeSort === 'DESC' ? 'ASC' : 'DESC';
    }
    this.sortMicronutrients();
  }

  onChangeStrategy(): void {
    this.ddrStrategy = DDRFactory.createDDRStandar(this.strategyName);
    this.data = this.ddrStrategy.concatDDRValues(this.data);
  }
}
